import { useStaticQuery, graphql } from 'gatsby'

export const useServiceAreasQuery = () => {
  const { wpPage } = useStaticQuery(graphql`
    query ServiceAreasQuery {
      wpPage(title: { eq: "Home" }) {
        serviceAreas {
          serviceAreas {
            backgroundImageMobile {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
            backgroundImageDesktop {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
            containerBackgroundMobile {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
            containerBackgroundDesktop {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP, sizes: "72vw")
                }
              }
            }
            image1 {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: [WEBP], sizes: "(min-width: 1024px) 42vw, 91vw")
                }
              }
            }
            image1AltText
            title1
            title2
            text
            locationIcon {
              localFile {
                publicURL
              }
            }
            countiesAndTowns {
              county
              towns
            }
            buttonText
          }
        }
      }
    }
  `)
  return wpPage.serviceAreas.serviceAreas
}
